import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import React, { useEffect, useState } from 'react';
import UsersTable from './_UsersTable.js';
import MyModal from 'helpers/MyModal.js';
import EditUser from './_EditUser.js';
import { stringGen } from 'helpers/utils.js';
import ConfirmAction from 'helpers/ConfirmationModal.js';
const URI = ApiEndpoint + 'account/';

const Users = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [openModal, setOpenModal] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [idUserForEditPassword, setIdUserForEditPassword] = useState(false);
  const [messageConfirm, setMessageConfirm] = useState(false);
  const [modalShowConfirmNewPass, setModalShowConfirmNewPass] = useState(false);
  const [usersList, setUsersList] = useState(false);
  const [idUserToEdit, setIdUserEdit] = useState(0);
  const handleClose = () => {
    setOpenModal(false);
    getUsersList();
  };
  const ModalHandleClosePassword = () => {
    setOpenChangePassword(false);
    setIdUserForEditPassword(0);
    getUsersList();
  };

  const handleConfirmPass = isConfirmed => {
    if (!isConfirmed) {
      return;
    }
    createNewUserPasword();
  };
  const getUsersList = async () => {
    console.log('entre a userslist');
    setUsersList(null);

    httpClient('GET', URI + 'users/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setUsersList(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getUsersList();
  }, []);

  const createNewUserPasword = () => {
    const newPass = stringGen();
    httpClient(
      'post',
      URI + 'userpass/',
      {
        iduser: idUserForEditPassword,
        password: newPass
      },
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setMessageConfirm('La contraseña nueva es: ' + newPass);
          setModalShowConfirmNewPass(true);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  return (
    <>
      {usersList && (
        <UsersTable
          users={usersList}
          setIdUser={setIdUserEdit}
          setOpenModal={setOpenModal}
          setIdUserForEditPassword={setIdUserForEditPassword}
          setOpenChangePassword={setOpenChangePassword}
        ></UsersTable>
      )}
      {openModal && (
        <MyModal
          id="id_myModal"
          title={(idUserToEdit > 0 ? 'Editar' : 'Agregar') + ' Usuario'}
          openModal={openModal}
          closeModal={handleClose}
        >
          <EditUser idUser={idUserToEdit} closeModal={handleClose}></EditUser>
        </MyModal>
      )}
      <ConfirmAction
        open={modalShowConfirmNewPass}
        handleClose={() => {
          setModalShowConfirmNewPass(false);
        }}
        title="Aviso"
        message={messageConfirm}
        ConfirmAction={() => {
          setModalShowConfirmNewPass(false);
        }}
        ConfirmTitle="Aceptar"
      ></ConfirmAction>
      <ConfirmAction
        open={openChangePassword}
        handleClose={ModalHandleClosePassword}
        title="Aviso"
        ConfirmAction={handleConfirmPass}
        message={'Desea Generar una nueva contraseña para este usuario?'}
      />
    </>
  );
};

export default Users;
